import type { RefObject } from 'react';
import { useLingui } from '@lingui/react/macro';

import AddToShortlistButton from '@rover/components/src/shortlist/components/AddToShortlistButton';
import { Props as ButtonProps } from '@rover/kibble/core/Button';
import type { EnhancedPersonSitterProfile } from '@rover/rsdk/src/apiClient/latest/model/enhancedPersonSitterProfile';

import type { PagePosition, ShortlistLayout } from './types';

type Props = ButtonProps & {
  sitter: EnhancedPersonSitterProfile | undefined;
  layout: ShortlistLayout;
  pagePosition: PagePosition;
  buttonRef: RefObject<HTMLElement | null>;
  onAdded: (count: number) => void;
};

const SIZING: Record<ShortlistLayout, Partial<ButtonProps>> = {
  header: { px: '6x' },
  stacked: { width: '100%' },
  legacy: { width: '100%' },
};

const ShortlistAddButton = ({
  sitter,
  layout,
  pagePosition,
  buttonRef,
  onAdded,
  ...other
}: Props): JSX.Element => {
  const { t } = useLingui();
  const firstName = sitter?.firstName;
  const text =
    layout === 'header' && firstName ? t`Add ${firstName} to contact list` : t`Add to contact list`;

  return (
    <AddToShortlistButton
      personOpk={sitter?.opk ?? ''}
      source="sitter-profile"
      removedText={text}
      removedIcon={null}
      removedVariant="primary"
      isToggle={false}
      onAdded={onAdded}
      {...SIZING[layout]}
      data-testid={`contact-button-shortlist-${pagePosition}`}
      {...other}
      webProps={{ ...other.webProps, ref: buttonRef }}
    />
  );
};

export default ShortlistAddButton;
